// src/pages/History/RenaissanceReformation/CatholicCounterReformationGo.jsx
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Renaissance_&_Reformation_-_Catholic_Counter-Reformation.png';

export default function HistoryPageCatholicCounterReformationGo() {
  return (
    <QuizPage
      title="History: Catholic Counter-Reformation"
      subTopic="Catholic Counter-Reformation"
      backgroundImage={historyImage}
      returnPath="/History-Catholic-Counter-Reformation"
    />
  );
}
